export default __webpack_public_path__ + "media/images/mailer-new/welcome-icons/share_step-on-a8f07418becb20efc9c88160f796987a.png";